/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import * as firebase from 'firebase';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService) {
  }

  ngOnInit(): void {
    firebase.initializeApp({  
		  // apiKey: "AIzaSyDpJtUY7gToOb3QKbnfBLqvhKm0b1l5Pic",
		  // authDomain: "gear-574f1.firebaseapp.com",
		  // databaseURL: "https://gear-574f1.firebaseio.com",
		  // projectId: "gear-574f1",
		  // storageBucket: "gear-574f1.appspot.com",
      // messagingSenderId: "817744747905"
      
      apiKey: "AIzaSyATSXWBi52L8zSuOcd5Impu5EleJ4rJDgM",
      authDomain: "punctualexpress-81577.firebaseapp.com",
      databaseURL: "https://punctualexpress-81577.firebaseio.com",
      projectId: "punctualexpress-81577",
      storageBucket: "punctualexpress-81577.appspot.com",
      messagingSenderId: "159519811782",
      appId: "1:159519811782:web:85e5e8f007d36dc9adcfc7",
      measurementId: "G-TQPXBTCB1R"
      });   
    this.analytics.trackPageViews();
  }
}
